export * from './device-with-wifi.class';

export * from './device-with-wifi-info.component';